import CodeEditor from '@/components/codeEditor/CodeEditor';
import { CodeEditorCorrectAnswer } from '@/models/_deprecated/ActivityProgress';
import { LanguageCodeEditorEnum } from '@/models/CodeEditorActivity';
import { ElementPreviewFactoryProps } from '../ElementPreviewFactory';

function CodeEditorFeedback({ answer }: ElementPreviewFactoryProps) {
  const { solutionCode, language } = answer as CodeEditorCorrectAnswer;

  return (
    <div className="w-11/12">
      <CodeEditor
        language={language || LanguageCodeEditorEnum.JAVASCRIPT}
        value={solutionCode}
        readOnly={true}
      />
    </div>
  );
}

export default CodeEditorFeedback;
